export default __webpack_public_path__ + "static/media/email_color.8e18847a.svg";